import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../../components/table/tableCustom';
import { ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import ContentHeading from '../../../../components/layout/content/ContentHeading';
import InputTextField from '../../../../components/input/inputTextField';
import { RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { dateTimeToView, dateToView } from '../../../../utils/date.utils';
import SwitchCustom from '../../../../components/switch/SwitchCustom';
import FilterSelect from '../../../../components/select/filterSelect';
import { Box, Divider, IconButton, MenuItem, Typography } from '@mui/material';
import InputDatePicker from '../../../../components/input/inputDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ChecklistIcon from '@mui/icons-material/Checklist';
import { PickerSelectionState } from '@mui/lab/internal/pickers/hooks/usePickerState';
import { CalendarPicker, LocalizationProvider, PickersDay } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { routeName } from '../../../../routes/routeName';
import OptionsButtonCustom from '../../../../components/button/OptionsButtonCustom';
import { alertActive, alertError, alertSuccess, swalError, swalSuccess } from '../../../../components/alert/swal';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import thLocale from "date-fns/locale/th";
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import StatusCustom from '../../../../components/status/statusCustom';
import { MeetingRoomApi } from '../../../../api/meeting-room/meeting-room.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import InputNewRangePicker from '../../../../components/input/inputRankPicker';
import { MeetingTypeApi } from '../../../../api/meeting-type/meeting-type.api';
import { MEETING_STATUS, renderStatus } from './enum/meeting-calendar.enum';
export default function MeetingCalendar() {
    const dayOfWeekFormatter = (day: any) => {
        const days: any = {
            "จ.": "จันทร์",
            "อ.": "อังคาร",
            "พ.": "พุธ",
            "พฤ.": "พฤหัสบดี",
            "ศ.": "ศุกร์",
            "ส.": "เสาร์",
            "อา.": "อาทิตย์",
        };
        return days[day] || day;
    };
    const navigate: NavigateFunction = useNavigate();
    const [data, setData] = useState<any[]>([]);
    const [meetingType, setMeetingType] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [date, setDate] = useState<any>(new Date());
    const { t } = useTranslation();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [keyword, setKeyword] = useState<string>("");
    const [id_meeting_type, setid_meeting_type] = useState<string>("ALL");
    const [status, setStatus] = useState<string>("ALL");
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const [tab, setTab] = useState<number>(0)
    const [startDate, setStartDate] = useState<string>("");

    const [endDate, setEndDate] = useState<string>("");
    const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
    const handleRangeDate = (value: any) => {
        setSelectedDateRange(value);
        setStartDate(moment(value[0]).format("YYYY-MM-DD"));
        setEndDate(moment(value[1]).format("YYYY-MM-DD"));
    };
    const handleClearRangeDate = () => {
        setSelectedDateRange([]);
        setStartDate("");
        setEndDate("");
    };
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: "#",
        },
        {
            id: "leave_type_name",
            width: '350px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("MEETING.MEETING_NAME"),
        },
        {
            id: "leave_type_name",
            width: '350px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("MEETING.MEETING_CATEGORY"),
        },
        {
            id: "leave_type_name",
            width: '250px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("MEETING.MEETING_DATE_RANGE"),
        },

        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("MEETING_CATEGORY.LAST_UPDATED_BY"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("MEETING_CATEGORY.LAST_UPDATED_DATE"),
        },
        {
            id: "status",
            disablePadding: false,
            width: '250px',
            sortable: false,
            align: "center",
            label: t("MEETING_CATEGORY.STATUS"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_meeting_room, meeting_room_name, meeting_type_name, meeting_date, status, modifier_name, modified_date } =
            objData;

        const objRenderData = {
            key: id_meeting_room,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: meeting_room_name,
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: meeting_type_name,
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: dateToView(meeting_date),
                },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modifier_name || '-',
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-",
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    component: <StatusCustom
                        disableMaxWidth
                        text={renderStatus(status)}
                        type={renderStatus(status)}
                    />,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableCopy
                            enableEdit
                            enableDelete
                            onViewClick={() => {
                                navigate(routeName.cms.MeetingCaledarDetail.replace(':id', id_meeting_room) + '?mode=VIEW')
                                // navigate(routeName.students.MeetingCaledarDetail.replace(':id', id_meeting_room))

                            }}
                            onCopy={() => {
                                handleCopy(id_meeting_room)
                            }}
                            onEditClick={() => {
                                navigate(
                                    routeName.cms.MeetingCaledarDetail.replace(':id', id_meeting_room)
                                );
                            }}
                            onDeleteClick={() => {
                                alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                    handleDelete(id_meeting_room)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (keyword) condition = { ...condition, keyword: keyword };
            if (startDate) condition = { ...condition, sdate: startDate };
            if (endDate) condition = { ...condition, edate: endDate };
            if (id_meeting_type !== 'ALL') condition = { ...condition, id_meeting_type: id_meeting_type };
            if (status !== 'ALL') condition = { ...condition, status: status };

            const res = await MeetingRoomApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, keyword, startDate, endDate, id_meeting_type, status]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    const getMeetingType = async () => {
        let condition: any = {
            page: 1,
            limit: 1000
        };

        const res = await MeetingTypeApi.list(condition);
        const data = res.data
        if (data?.status < 300) {
            setMeetingType(data?.data.items?.filter((x: any) => x?.status === 'active'));

        }
    }
    const handleCopy = async (id: number) => {
        alertActive(t("คัดลอก"), t("ต้องการคัดลอก หรือไม่ ?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await MeetingRoomApi.copy(id).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("คัดลอก"), t("คัดลอก เรียบร้อย"))
                    loadData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("คัดลอก"), t("คัดลอก ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    useEffect(() => {
        getMeetingType()
    }, [])
    const handleDelete = async (id: any) => {
        await MeetingRoomApi.delete(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('MEETING.DELETE_MEETING_CALENDAR_SUCCESS'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    return (
        <div>
            <ContentHeading
                title={t("MEETING.MEETING_CALENDAR")}
                detail={t("MEETING_CATEGORY.PLEASE_SELECT_OPTION")}
                contentRight={
                    <div style={{ display: 'flex', gap: '5px' }}>
                        <IconButton onClick={() => setTab(0)}>
                            <ChecklistIcon sx={{ color: tab === 0 ? '#000' : '#DDE1EB' }} />
                        </IconButton>
                        <Divider orientation="vertical" variant="middle" flexItem />
                        <IconButton onClick={() => setTab(1)}>
                            <CalendarMonthIcon sx={{ color: tab === 1 ? '#000' : '#DDE1EB' }} />
                        </IconButton>

                    </div>
                }
            />
            {tab === 0 &&
                <>
                    <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                        <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                            <InputTextField
                                startAdornment={<SearchOutlined />}
                                placeholder={t("MEETING.SEARCH_MEETING_NAME")}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setKeyword(e.target.value)
                                    // handleChangeValueSearch("leave_type_name", e.target.value);
                                }}
                                value={keyword}
                            />


                        </article>
                        <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">

                            <FilterSelect
                                value={id_meeting_type || ""}
                                labelId="year-id"
                                selectId="year-select-id"
                                options={[{ meeting_type_name: 'ทั้งหมด', id_meeting_type: 'ALL' }, ...meetingType].map((item: any, index: number) => (
                                    <MenuItem value={item?.id_meeting_type} key={index + 1}>
                                        {item?.meeting_type_name}
                                    </MenuItem>
                                ))}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setid_meeting_type(e.target.value)
                                }
                                    // handleChangeValueSearch("year", e.target.value)
                                }
                            />

                        </article>
                        <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                            <InputNewRangePicker
                                value={selectedDateRange}
                                onchange={handleRangeDate}
                                onClear={handleClearRangeDate}
                                allowClear
                            />
                        </article>
                        <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">

                            <FilterSelect
                                value={status || ""}
                                labelId="year-id"
                                selectId="year-select-id"
                                options={[{ id: 'ALL', name: 'ทั้งหมด' },
                                     { id: 'DRAFT', name: t('บันทึกร่าง') },
                                     { id: 'NOT_START_YET', name: t('MEETING.MEETING_NOT_DUE_YET') },
                                     { id: 'ON_GOING', name: t('อยู่ระหว่างการประชุม') },
                                     { id: 'DELAY', name: t('เลยกำหนดการประชุม') },
                                      { id: 'COMPLETED', name: t('MEETING.MEETING_COMPLETED') }].map((item: any, index: number) => (
                                    <MenuItem value={item?.id} key={index + 1}>
                                        {item?.name}
                                    </MenuItem>
                                ))}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setStatus(e.target.value)
                                }
                                    // handleChangeValueSearch("year", e.target.value)
                                }
                            />

                        </article>

                        <article
                            className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12"
                            style={{
                                display: "flex",
                                justifyContent: "end",
                            }}
                        >
                            <ButtonPrimary
                                onClick={() => {
                                    navigate(routeName.cms.MeetingCaledarCreate);
                                }}
                                mode="add"
                                buttonName={t("MEETING.ADD_MEETING")}
                            />
                        </article>
                    </div>

                    <section className="w-full mt-10">
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={
                                data.map((data: any, i: any) => {
                                    return renderData(data, i);
                                })
                            }
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                </>}
            {tab === 1 &&
                <div style={{ width: '100%' }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={thLocale}>
                        <Box sx={{
                            "& .MuiPickersDay-root": { width: "200px", height: '60px', fontSize: '16px' }, '& .MuiCalendarPicker-root': {
                                width: "100%",
                                height: 'auto',
                                maxHeight: 'none'
                            },
                            '& .MuiTypography-caption': {
                                width: "200px", height: '60px', fontSize: "16px", fontWeight: 'bold'
                            },
                            '& .MuiPickersCalendarHeader-label': {
                                fontSize: "18px", fontWeight: 'bold'
                            },
                            boxShadow: '0px 0px 8.8px 0px #00000026',
                            borderRadius: '16px',

                            gap: '20px',
                            marginTop: "20px",
                            marginBottom: '20px'
                        }}>

                            <CalendarPicker
                                date={date}

                                onChange={(newDate) => { setDate(newDate) }}
                                views={["day"]}
                                disableFuture={false}
                                reduceAnimations
                                renderDay={(day, selectedDates, pickersDayProps) => {
                                    const a = data?.filter((item: any) => dateToView(item?.meeting_date) === dateToView(day))?.filter((item: any) => item?.status === MEETING_STATUS.COMPLETED)?.length
                                    const b = data?.filter((item: any) => dateToView(item?.meeting_date) === dateToView(day))?.filter((item: any) => item?.status === MEETING_STATUS.NOT_START_YET)?.length
                                    const c = data?.filter((item: any) => dateToView(item?.meeting_date) === dateToView(day))?.filter((item: any) => item?.status === MEETING_STATUS.ON_GOING)?.length
                                    const d = data?.filter((item: any) => dateToView(item?.meeting_date) === dateToView(day))?.filter((item: any) => item?.status === MEETING_STATUS.DELAY)?.length
                                    const e = data?.filter((item: any) => dateToView(item?.meeting_date) === dateToView(day))?.filter((item: any) => item?.status === MEETING_STATUS.DRAFT)?.length
                                    return (
                                        <div style={{ position: 'relative' }}>
                                            <PickersDay
                                                {...pickersDayProps}
                                                sx={{
                                                    borderRadius: '10px'
                                                }}
                                            />
                                            <div style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', gap: '10px' }}>
                                                {a > 0 && <div style={{ backgroundColor: '#0F9F0C', color: '#fff', width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: '50%' }}>{a}</div>}
                                                {b > 0 && <div style={{ backgroundColor: '#0A77FF', color: '#fff', width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: '50%' }}>{b}</div>}
                                                {c > 0 && <div style={{ backgroundColor: '#B54708', color: '#fff', width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: '50%' }}>{c}</div>}
                                                {d > 0 && <div style={{ backgroundColor: '#B42318', color: '#fff', width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: '50%' }}>{d}</div>}
                                                {e > 0 && <div style={{ backgroundColor: '#B54708', color: '#fff', width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: '50%' }}>{e}</div>}
                                            </div>
                                        </div>

                                    );
                                }}
                                dayOfWeekFormatter={dayOfWeekFormatter}
                            />
                        </Box>
                    </LocalizationProvider>
                    <ButtonPrimary
                        onClick={() => {
                            navigate(routeName.cms.MeetingCaledarCreate);
                        }}
                        mode="add"
                        buttonName={t("MEETING.ADD_MEETING")}
                        btnProps={{
                            width: "100%"
                        }}
                    />

                    <div>
                        <div className='my-4'>
                            {data?.filter((item: any) => dateToView(item?.meeting_date) === dateToView(date)).map((data: any, i: any) => {
                                return (
                                    <div style={{
                                        boxShadow: '0px 0px 8.8px 0px #00000026',
                                        padding: '40px',
                                        borderRadius: '16px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '20px',
                                        marginBottom: '20px'
                                    }}>

                                        <div>
                                            <Typography>{data?.meeting_room_name}</Typography>
                                            <Typography>{t('MEETING.MEETING_CATEGORY')} : {data?.meeting_type_name}</Typography>
                                            <Typography>{t('MEETING.DATE')} : {dateToView(data?.meeting_date)}</Typography>
                                            <Typography>{t('MEETING.TIME')} : {data?.meeting_start_time} - {data?.meeting_end_time}</Typography>
                                            <Typography><FmdGoodOutlinedIcon />{data?.meeting_room_location || '-'}</Typography>

                                        </div>
                                        <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                            <div style={{ width: '300px' }}>
                                                <StatusCustom
                                                    disableMaxWidth
                                                    text={renderStatus(data?.status)}
                                                    type={renderStatus(data?.status)}
                                                />
                                            </div>
                                            {/* {data?.status === 'NOT_START_YET' ?
                                                <div style={{
                                                    backgroundColor: '#FFFAEB',
                                                    width: "100%",
                                                    maxWidth: 250,
                                                    minHeight: 30,
                                                    display: 'flex',
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: "8px 8px",
                                                    borderRadius: '16px',
                                                    wordBreak: "break-word", // ป้องกันข้อความล้น
                                                    whiteSpace: "normal", // ให้ข้อความขึ้นบรรทัดใหม่
                                                }}>
                                                    <Typography sx={{ color: "#B54708" }}> {t('MEETING.MEETING_NOT_DUE_YET')}</Typography>
                                                </div> : <div style={{
                                                    backgroundColor: '#ECFDF3',
                                                    width: "100%",
                                                    maxWidth: 250,
                                                    minHeight: 30,
                                                    display: 'flex',
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: "8px 8px",
                                                    borderRadius: '16px',
                                                    wordBreak: "break-word", // ป้องกันข้อความล้น
                                                    whiteSpace: "normal", // ให้ข้อความขึ้นบรรทัดใหม่
                                                }}>
                                                    <Typography sx={{ color: "#0F9F0C" }}> {t('MEETING.MEETING_COMPLETED')}</Typography>
                                                </div>} */}
                                            <OptionsButtonCustom
                                                enableView
                                                enableEdit
                                                enableDelete
                                                onViewClick={() => {
                                                    navigate(routeName.cms.MeetingCaledarDetail.replace(':id', data?.id_meeting_room) + '?mode=VIEW')
                                                    // navigate(routeName.students.MeetingCaledarDetail.replace(':id', id_meeting_room))

                                                }}
                                                onCopy={() => {
                                                    handleCopy(data?.id_meeting_room)
                                                }}
                                                onEditClick={() => {
                                                    navigate(
                                                        routeName.cms.MeetingCaledarDetail.replace(':id', data?.id_meeting_room)
                                                    );
                                                }}
                                                onDeleteClick={() => {
                                                    alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                                        handleDelete(data?.id_meeting_room)
                                                    })
                                                }} />
                                        </div>

                                    </div>
                                )
                            })}


                        </div>
                    </div>
                </div>}
        </div>
    )
}
